import React, { useState, useRef, useEffect } from 'react';
import { If, Then } from 'react-if';
import nookies, { setCookie } from 'nookies';
import { NextSeo } from 'next-seo';
import { useUserAgent } from 'next-useragent';
import d from 'dayjs';
import { cityFrom } from 'lvovich';
import cc from 'classcat';
import Interweave from 'interweave';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { apiProxy } from '../../lib/api';
import { RootStoreProvider } from '../../providers/RootStoreProvider';
import { Layout } from '../../components/Layout';
import { Text, Anchor } from '../../components/Text';
import { Icon } from '../../components/Icon';
import { Button } from '../../components/Button';
import { Features } from '../../components/Features';
import { Badge } from '../../components/Badge';
import { Modal } from '../../components/Modal';
import { Motivator } from '../../components/Motivator';
import { Collapsed } from '../../components/Collapsed';
import { declOfNum } from '../../utils/declOfNum';
import styles from '../../styles/cruizPage.module.sass';
import { randomInteger } from '../../utils/randomInteger';
import { faqItems } from '../../resources/faqitemsea';
import { VendorLink } from '../../components/CruisePageComponents/VendorLink';
// import { cityLinks } from '../../resources/cityLinks';
import { isClient } from '../../utils/isClient';
import { ExcursionProgramm } from '../../components/CruisePageComponents/ExcursionProgramm';
import { PricePanel } from '../../components/CruisePageComponents/PricePanel';
import { scrollToUtil } from '../../utils/scrollToUtil';
import { Reviews } from '../../components/Reviews';
import { StorageManager } from '../../lib/StorageManager';
import { PickCaute } from '../../components/PickCaute';
import { CruiseDescription } from '../../components/CruisePageComponents/CruiseDescription';
import { GenericList } from '../../components/CruisePageComponents/GenericList';
import { CancellationAndReturn } from '../../components/CruisePageComponents/CancellationAndReturn';
import { MainGallery } from '../../components/CruisePageComponents/MainGallery';
import { TravelTime } from '../../components/TravelTime';
import { yandexDataLayer, yandexUserLayer } from '../../lib/yandexDataLayer';
import { InfoblockSliders } from '../../components/InfoblockSliders';
import { BreadCrumbs } from '../../components/BreadCrumbs';
import { ExcursionGallery } from '../../components/ExcursionGallery';
import { IconSVG } from '../../components/SpriteSVG';
import { SearchStoreProvider } from '../../providers/SearchStoreProvider';
import { inArray } from '../../utils/inArray';
import { ModalReload } from '../../components/ModalReload';
import { redirectFromTo } from '../../utils/redirectFromTo';
import { useHiddenWithCookie } from '../../hooks/useHiddenWithCookie';
import { YaAndGaCruisePage } from '../../lib/YaAndGaHelper';
import { logger } from '../../lib/logger';
import { formatDateEnd, formatDateStart } from '../../utils/useFormatDate';
import { ModalShareSocial } from '../../components/ModalShareSocial';
import { ActualPanel } from '../../components/ActualPanel';
import { isNewYear } from '../../utils/isBlackFridayCheck';
import { sendVKPixelEvent } from '../../lib/sendVKPixelEvent';

const BannerTop = dynamic(() =>
  import('../../components/CookieBanner').then(mod => mod.CookieBanner),
);

export default function SeaCruizPage({
  uaString,
  cookies,
  store: {
    user,
    cruiz,
    places,
    reviews,
    position,
    motivatorReady,
    motivatorColor,
    motivatorEmoji,
    clientBuy,
    idCruiz,
    token,
    schema,
    popularPopdirs,
  },
  canonicalUrl,
}) {
  const ua = useUserAgent(uaString || window.navigator.userAgent);
  const { isMobile, isTablet } = ua;
  const router = useRouter();
  const currentLink = router.asPath;

  const options = {
    buttons: {
      showThumbnailsButton: false,
      showAutoplayButton: false,
      showFullscreenButton: false,
    },
    thumbnails: {
      showThumbnails: false,
    },
  };

  const [cruizeFeaturesIsOpen, setCruizeIsOpen] = useState(false);
  const [cruizeRoutesIsOpen, setCruizeRoutesIsOpen] = useState(false);
  const [showFixedBtn, setShowFixedBtn] = useState(false);
  const [servicesDescIsOpen, setServicesDescIsOpen] = useState(false);
  const [showExcDescription, setShowExcDescription] = useState(false);

  const {
    ship_info: {
      t_title,
      category_name,
      company,
      ship_direction,
      // exc_included,

      ship_fotos: { maxi, mini } = {},
      facilities,
      description,
      placing_children,
      price_includes = {},
      owner_id,
      // promotion,
      cabin_cancellation,
      url,
      seat_of_the_ship,
      cauta_count,
      construction_date,
      restoration_date,
    } = {},
    cruise: {
      route_full = '',
      kr_date_start,
      kr_date_end,
      min_price,
      min_price_discounted,
      kr_days,
      free_places_left,
      ship_id,
      special_note,
      city_start,
      vendor_link,
      return_trip,
      route_img,
      cruise_id,
      tariffs,
    } = {},
    new_cancellation: { policy_details } = {},
    discounts,
    timetable_excursions = {},
  } = cruiz;

  const startDate = d(kr_date_start).format('DD MMMM YYYY');
  const endDate = d(kr_date_end).format('DD MMMM YYYY');

  const shipDetail = {
    restorationDate: restoration_date,
    constructionDate: construction_date,
    cabinCount: cauta_count,
    passengerCount: seat_of_the_ship,
    title: t_title,
  };

  const shortStartDate = formatDateStart(kr_date_start, kr_date_end);
  const shortEndDate = formatDateEnd(kr_date_end, { isCruise: true });
  const isAstoria = owner_id === 100022;
  const favoriteData = {
    id: idCruiz,
    title: t_title,
    price: min_price,
    route: route_full,
    imgUrl: maxi?.[0]?.url,
    places: free_places_left,
    category: category_name,
    startDate: kr_date_start,
    endDate: kr_date_end,
    images: route_img,
    special_note,
    kr_days,
    ship_id,
    isSea: true,
  };
  const cruizDetail = {
    id: idCruiz,
    name: `${t_title} с ${shortStartDate} по ${shortEndDate}`,
    brand: company || 'Море',
    category: `${
      ship_direction === 'sea' ? 'Море' : 'Река'
    }/${category_name}/${t_title}/${route_full}`,
    list: cruiz?.cruise?.directionName || '',
    price: min_price,
    quantity: 1,
  };
  const timetableExcursions = Object.values(timetable_excursions);
  const elRef = useRef();
  const badgeReviewsRef = useRef();
  const badgeClassRef = useRef();
  const servicesRef = useRef();
  const badgeSaleRef = useRef();
  // const activeCitySlug = Object.keys(cityLinks).find(key =>
  //   route_full.startsWith(cityLinks[key]),
  // );

  let classCategoryReady;

  if (position === 2) {
    motivatorReady += cityFrom(city_start);
  }

  const headerHeight = isMobile ? 124 : 148;

  useEffect(() => {
    // Яндекс метрика - информация о пользователи и типе страницы
    yandexUserLayer(user?.user?.id, user?.user?.group, true);
    // YaAndGaCruisePage('isSeaPage');
    // Яндекс метрика - просмотр товара
    yandexDataLayer('detail', cruizDetail);
    sendVKPixelEvent('viewProduct', { product_id: idCruiz, value: min_price });

    if (isClient) {
      // Добавление в просмотренные
      const viewed = StorageManager.get('viewed') ?? [];
      const isCurrentViewed = viewed.findIndex(i => i === cruise_id) !== -1;

      if (!isCurrentViewed) {
        StorageManager.set('viewed', [...viewed, cruise_id]);
      }
    }

    if (isClient && isMobile) {
      document.addEventListener('scroll', () => {
        const windowTop = window.pageYOffset;
        const windowBottom = windowTop + window.innerHeight;

        // Параметры первого блока, который предлагает выбрать каюту
        const pickHeight = badgeClassRef?.current?.clientHeight;
        const pickTop = badgeClassRef?.current?.offsetTop;
        const pickBottom = pickHeight + pickTop;

        // Параметры блока со списком кают
        const chooseHeight = elRef?.current?.clientHeight;
        const chooseTop = elRef?.current?.offsetTop;
        const chooseBottom = chooseHeight + chooseTop;

        if (
          pickBottom - 130 - headerHeight > windowTop ||
          (chooseTop + 100 < windowBottom &&
            chooseBottom - headerHeight - 80 > windowTop)
        ) {
          setShowFixedBtn(false);
        } else {
          setShowFixedBtn(true);
        }
      });
    }
  }, []);

  // TODO: Переписать как ключ значение
  if (category_name === 'Люкс') {
    classCategoryReady = 'lux';
  } else if (category_name === 'Комфорт') {
    classCategoryReady = 'comfort';
  } else if (category_name === 'Стандарт') {
    classCategoryReady = 'standart';
  } else if (category_name === 'Эконом') {
    classCategoryReady = 'eco';
  }

  const scrollTo = scrollToUtil(headerHeight);

  const pageRoute = [
    { title: 'Поиск круизов', link: 'https://kruiz.online/result' },
    { title: `Круиз на лайнере ${t_title}`, link: '' },
  ];
  const [closeBannersTop, setCloseBannersTop] = useState(
    cookies?.closeBanner !== undefined || cookies?.closeBanner === 'false',
  );
  const currentDate = d();
  const timeToCookie = currentDate.add(1, 'h');
  setCookie(null, 'closeBanner', 'false');
  const openBanner = () => {
    setCloseBannersTop(false);
    setCookie(null, 'closeBanner', 'false');
  };
  useHiddenWithCookie(openBanner);

  useEffect(() => {
    if (cruiz.actualInfo.type === 'inProgress') {
      window.ym(35441960, 'reachGoal', 'cruise_page_visit_during_trip');
    } else if (cruiz.actualInfo.type === 'complete') {
      window.ym(35441960, 'reachGoal', 'cruise_page_visit_after_trip');
    }
    if (clientBuy) {
      window.ym(
        35441960,
        'reachGoal',
        'cruise_page_visit_by_authenticated_user_for_purchased_cruise',
      );
    }
  }, []);

  const statusCruiseBuy = () => {
    switch (cruiz.actualInfo.type) {
      case 'inProgress':
        return 'Уже в пути';
      case 'complete':
        return 'Завершен';
      default:
        return '';
    }
  };

  const closeBanners = true;
  return (
    <SearchStoreProvider
      hydrationData={{ user, cruiz, reviews, idCruiz, places, token }}
    >
      <RootStoreProvider
        hydrationData={{ user, cruiz, reviews, idCruiz, places, token }}
      >
        <NextSeo
          title={`Круиз по маршруту ${route_full} ${startDate} - ${endDate} от ${min_price} рублей`}
          description={`Забронируйте онлайн морской Круиз по маршруту ${route_full} с ${startDate} по ${endDate} на лайнере ${t_title} рублей от ${min_price} рублей.`}
          keywords={`Морской круиз по маршруту ${route_full} на ${t_title}`}
          additionalLinkTags={[
            {
              rel: 'shortcut icon',
              href: '/favicon.ico?v=2',
            },
          ]}
          canonical={canonicalUrl}
        />
        <Layout
          lsitMenu={[]}
          isMobile={isMobile}
          isTablet={isTablet}
          withoutForm
          showTopContent={!closeBannersTop}
          popularPopdirs={popularPopdirs}
          topContent={
            <div>
              <BannerTop
                isOpen={closeBannersTop}
                onOpen={setCloseBannersTop}
                timeToCookie={timeToCookie}
                isMobile={isMobile}
                isTablet={isTablet}
              />
            </div>
          }
        >
          <div className="container--block">
            <div>
              <BreadCrumbs routeCrumbs={pageRoute} />
            </div>
            <div
              style={
                isMobile
                  ? {
                      display: 'flex',
                      justifyContent: 'space-between',
                      flexDirection: 'column',
                    }
                  : { display: 'flex', justifyContent: 'space-between' }
              }
            >
              <div style={{ maxWidthidth: '920px' }}>
                {' '}
                <Text
                  component="h1"
                  variant={isMobile ? 'heading-4' : 'heading-1'}
                >
                  Круиз на лайнере {t_title}{' '}
                  {cruiz.actualInfo && (
                    <div className={styles.progressBadge}>
                      <Badge size="sm" view={cruiz.actualInfo.type}>
                        {statusCruiseBuy()}
                      </Badge>
                    </div>
                  )}
                </Text>
              </div>{' '}
              <ModalShareSocial link={currentLink} isMobile={isMobile} />
            </div>

            <div className={styles.topBar}>
              <div className={styles.badgeContent}>
                <div className={styles.badgeItemClass}>
                  <Button view="text" onClick={() => scrollTo(servicesRef)}>
                    <Badge
                      view={classCategoryReady}
                      icon={classCategoryReady}
                      size={isMobile ? 'sm' : 'md'}
                    >
                      {category_name}
                    </Badge>
                  </Button>
                </div>
                <div className={styles.badgeItem}>
                  {isNewYear() && (
                    <Button view="text">
                      <Badge
                        view="newYear"
                        icon={'newYear'}
                        size={isMobile ? 'sm' : 'md'}
                      >
                        новогодний кешбэк
                      </Badge>
                    </Button>
                  )}
                </div>
                {!!special_note && (
                  <div className={styles.badgeItem}>
                    <Button
                      view="text"
                      ref={badgeSaleRef}
                      onClick={() => {
                        badgeSaleRef.current.scrollIntoView({
                          behavior: 'smooth',
                        });
                      }}
                    >
                      <Badge
                        view="season"
                        icon={
                          <IconSVG
                            name={'promo/badgeSeason'}
                            width={18}
                            height={18}
                          />
                        }
                        size={isMobile ? 'sm' : 'md'}
                      >
                        {special_note}
                      </Badge>
                    </Button>
                  </div>
                )}
                {reviews && !!reviews.length && (
                  <div className={styles.badgeItemClass}>
                    <Button
                      view="text"
                      onClick={() => scrollTo(badgeReviewsRef)}
                    >
                      <Badge
                        view="rewies"
                        icon="💬"
                        size={isMobile ? 'sm' : 'md'}
                      >
                        {`${reviews.length}
              ${declOfNum(reviews.length, ['отзыв', 'отзыва', 'отзывов'])}`}
                      </Badge>
                    </Button>
                  </div>
                )}
                <div className={styles.badgeItem}>
                  {free_places_left < 25 && free_places_left > 0 && (
                    <Button view="text" onClick={() => scrollTo(elRef)}>
                      <Badge
                        view="hot"
                        icon="fire"
                        size={isMobile ? 'sm' : 'md'}
                      >
                        {`Осталось ${free_places_left}
              ${declOfNum(free_places_left, ['каюта', 'каюты', 'кают'])}`}
                      </Badge>
                    </Button>
                  )}
                </div>
              </div>
              {/* <ModalShareSocial link={currentLink} isMobile={isMobile} /> */}
            </div>
            {mini && maxi && t_title && (
              <MainGallery
                ship_id={ship_id}
                reviews={reviews}
                maxi={maxi}
                mini={mini}
                isMobile={isMobile}
                category={{ name: category_name, type: classCategoryReady }}
                title={t_title}
                isSea
              />
            )}
            <div className={styles.contentWrapper}>
              <div className={styles.mainContent}>
                <TravelTime
                  size="lg"
                  className={styles.dateBlock}
                  start={shortStartDate}
                  end={shortEndDate}
                  days={kr_days}
                />
                <div>
                  <div className={styles.route}>
                    {return_trip === 0 ? (
                      <Text>
                        {route_full}{' '}
                        <span className={styles.returnTrip}>
                          (Без возвращения)
                        </span>
                      </Text>
                    ) : (
                      route_full
                    )}
                    {timetableExcursions.length !== 0 && (
                      <div className={styles.buttonWrapper}>
                        <Button
                          size="sm"
                          onClick={() => {
                            setCruizeRoutesIsOpen(true);
                          }}
                        >
                          Открыть маршрут и экскурсии
                        </Button>
                      </div>
                    )}
                  </div>
                  {vendor_link && (
                    <VendorLink vendorLink={vendor_link} isMobile={isMobile} />
                  )}
                </div>

                {isAstoria && (
                  <div className={styles.downloadPDFWrapper}>
                    <Icon
                      rightGap={8}
                      icon={
                        <IconSVG
                          name={'common/download'}
                          width={24}
                          height={24}
                        />
                      }
                      title={
                        'Скачать pdf с экскурсионной программой Astoria Grande'
                      }
                    />
                    <Anchor
                      href={
                        'https://kruiz.online/files/uploads/AstoriaGrande.pdf'
                      }
                      variant="newPromo"
                    >
                      Экскурсионная программа Astoria Grande.pdf
                    </Anchor>
                  </div>
                )}

                {isMobile && cruiz?.actualInfo?.status && (
                  <PricePanel
                    cruizDetail={cruizDetail}
                    price={min_price}
                    onChoose={() => scrollTo(elRef)}
                    priceDiscounted={min_price_discounted || min_price}
                    discounts={discounts}
                    elRef={badgeClassRef}
                    data={favoriteData}
                    titleShip={t_title}
                    cruiseDateS={kr_date_start}
                    cruiseDateE={kr_date_end}
                    cruiseDays={kr_days}
                    users={user}
                    isSea
                    disablePickCuteSea={inArray(
                      [10008, 100010, 100020, 10009, 100029, 100028],
                      [cruiz.cruise.provider_id],
                    )}
                    isMobile={isMobile}
                  />
                )}
                {isMobile && !cruiz?.actualInfo?.status && (
                  <div className={styles.actualPanel}>
                    <ActualPanel
                      actualInfo={cruiz.actualInfo}
                      url={url}
                      type={cruiz.actualInfo.type}
                    />
                  </div>
                )}
                {isMobile && (
                  <>
                    <div
                      style={{
                        maxWidth: '390px',
                      }}
                    >
                      {cruiz.cruise.infoblock.length !== 0 && (
                        <InfoblockSliders
                          type="info"
                          content={cruiz.cruise.infoblock}
                        />
                      )}
                    </div>
                  </>
                )}
                {/* Что включено в стоимость */}
                {price_includes?.on && price_includes?.off && (
                  <GenericList
                    title="Что включено в стоимость"
                    items={price_includes.on}
                    additional={price_includes.off}
                    btn={{ open: 'Показать еще', close: 'Скрыть услуги' }}
                  />
                )}
                {cruiz.ship_info?.booking_conditions && (
                  <section>
                    <Text component="h2" variant="heading-4">
                      Условия бронирования круиза
                    </Text>
                    <div
                      className={cc([
                        showExcDescription ? [] : [styles.excClipper],
                      ])}
                    >
                      <Interweave
                        content={cruiz.ship_info?.booking_conditions}
                      />
                    </div>
                    <div className={styles.buttonClipper}>
                      {!showExcDescription ? (
                        <Button
                          onClick={() => {
                            setShowExcDescription(!showExcDescription);
                          }}
                          view="sm"
                        >
                          Открыть условия
                        </Button>
                      ) : (
                        <Button
                          onClick={() => {
                            setShowExcDescription(!showExcDescription);
                          }}
                          view="sm"
                        >
                          Скрыть условия
                        </Button>
                      )}
                    </div>
                  </section>
                )}
                {/* {isMobile && <BenefitSlider />} */}
                {/* <section className={styles.section}> */}
                {/*   <Text component="h2" variant="heading-3"> */}
                {/*     Удобства в каютах */}
                {/*   </Text> */}
                {/* </section> */}
                {/* <div className={styles.facilitiesButton}> */}
                {/*   <ModalCabinFacilities /> */}
                {/* </div> */}
                {/* Условия размещения с детьми */}
                {/* {promotion && (
                <section>
                  <Text component="h2" variant="heading-4">
                    Акция «50 евро»
                  </Text>
                  <Text>{promotion}</Text>
                </section>
              )} */}
                {placing_children && (
                  <GenericList
                    title="Условия размещения с детьми"
                    items={placing_children}
                    btn={{ open: 'Все условия', close: 'Закрыть условия' }}
                    limit={1}
                  />
                )}
                {isMobile && (
                  <div className={styles.mobileMotivator}>
                    <Motivator
                      emoji={motivatorEmoji}
                      textcolor={motivatorColor}
                    >
                      {motivatorReady}
                    </Motivator>
                  </div>
                )}
              </div>
              {!isMobile && (
                <aside className={styles.aside}>
                  {cruiz?.actualInfo?.status ? (
                    <div className={styles.innerAside}>
                      <PricePanel
                        cruizDetail={cruizDetail}
                        price={min_price}
                        onChoose={() => scrollTo(elRef)}
                        priceDiscounted={min_price_discounted || min_price}
                        discounts={discounts}
                        data={favoriteData}
                        titleShip={t_title}
                        cruiseDateS={kr_date_start}
                        cruiseDateE={kr_date_end}
                        cruiseDays={kr_days}
                        users={user}
                        isSea
                        isRequest
                        disablePickCuteSea={inArray(
                          [10008, 100010, 100020, 10009, 100029, 100028],
                          [cruiz.cruise.provider_id],
                        )}
                        isMobile={isMobile}
                      />
                    </div>
                  ) : (
                    <div className={styles.actualPanel}>
                      <ActualPanel
                        actualInfo={cruiz.actualInfo}
                        url={url}
                        type={cruiz.actualInfo.type}
                      />
                    </div>
                  )}

                  <div>
                    {cruiz.cruise?.infoblock.length !== 0 && (
                      <InfoblockSliders
                        type="info"
                        content={cruiz.cruise?.infoblock}
                      />
                    )}
                  </div>
                </aside>
              )}
            </div>
          </div>
          {cruiz?.actualInfo?.status && (
            <div ref={elRef}>
              <PickCaute
                isMobile={isMobile}
                isTablet={isTablet}
                isSea
                disablePickCuteSea={inArray(
                  [10008, 100010, 100020, 10009, 100029, 100028],
                  [cruiz.cruise.provider_id],
                )}
                isSeaCabin
                items={tariffs}
                scheme={schema}
                isAstoria={isAstoria}
                titleShip={t_title}
                cruiseDateS={kr_date_start}
                cruiseDateE={kr_date_end}
                cruiseDays={kr_days}
                routeFull={route_full}
                users={user}
                idCruiz={idCruiz}
                minPrice={min_price}
                closeBanners={closeBanners}
              />
            </div>
          )}

          <div className="container container--start">
            <div
              className={
                cruiz?.actualInfo?.status
                  ? styles.contentWrapper
                  : styles.contentWrapperNoActual
              }
            >
              <div className={styles.mainContent}>
                <section>
                  <div className={styles.headShips}>
                    <Text component="h2" variant="heading-4">
                      {'О Лайнере'}
                    </Text>
                    <a
                      href={`/ships/${url}`}
                      rel={'noreferrer'}
                      className={styles.headShipsLink}
                    >
                      <IconSVG
                        name={'common/blueShip'}
                        width={24}
                        height={24}
                      />
                      {t_title}
                    </a>
                  </div>
                  <CruiseDescription
                    desc={description}
                    url={url}
                    shipDetail={shipDetail}
                    aboutShip={'лайнеру'}
                    isMobile={isMobile}
                  />
                </section>
                <section className={styles.section} ref={servicesRef}>
                  <Text component="h2" variant="heading-4">
                    Услуги на борту
                  </Text>
                  <Features features={facilities} />
                </section>
                <CancellationAndReturn
                  policy_details={policy_details}
                  cabin_cancellation={cabin_cancellation}
                />
                <div className={styles.allRiviews} ref={badgeReviewsRef}>
                  {reviews && !!reviews.length && (
                    <>
                      <section className={styles.reviews}>
                        <h2 className="visually-hidden">Отзывы круизов</h2>

                        <div className={styles.reviewsHeader}>
                          <div className={styles.reviewsInfo}>
                            <Text component="h3" variant="heading-6">
                              Отзывы о круизе
                            </Text>
                            <div className={styles.reviewsCount}>
                              <Text variant="text-7">{reviews.length}</Text>
                            </div>
                          </div>
                        </div>
                        <div className={styles.rewiesAction}>
                          <Anchor
                            href="http://kruiz.online/reviews"
                            variant="linkAsbutton2"
                          >
                            Написать отзыв
                          </Anchor>
                        </div>
                      </section>
                      <Reviews items={reviews} isMobile={isMobile} />
                    </>
                  )}
                </div>
                <section className={styles.section}>
                  <Text component="h2" variant="heading-4">
                    Часто задаваемые вопросы
                  </Text>
                  <Collapsed items={faqItems} shorter isCruis />

                  <br />
                </section>
              </div>

              {!isMobile && cruiz?.actualInfo?.status && (
                <aside className={styles.aside}>
                  <div className={styles.innerAside}>
                    <PricePanel
                      cruizDetail={cruizDetail}
                      price={min_price}
                      onChoose={() => scrollTo(elRef)}
                      priceDiscounted={min_price_discounted || min_price}
                      discounts={discounts}
                      data={favoriteData}
                      titleShip={t_title}
                      cruiseDateS={kr_date_start}
                      cruiseDateE={kr_date_end}
                      cruiseDays={kr_days}
                      users={user}
                      isSea
                      disablePickCuteSea={inArray(
                        [10008, 100010, 100020, 10009, 100029, 100028],
                        [cruiz.cruise.provider_id],
                      )}
                      isMobile={isMobile}
                    />
                    {/* <BenefitSlider /> */}
                  </div>
                </aside>
              )}
            </div>
            {/* Фиксированная кнопка */}
            <If condition={isMobile && showFixedBtn}>
              <Then>
                <div className={styles.fixedBtnWrapper}>
                  <Button
                    size="semi-lg"
                    topGap
                    fullWidth
                    background="primary"
                    onClick={() => scrollTo(elRef)}
                  >
                    Выбрать каюту
                  </Button>
                </div>
              </Then>
            </If>

            <Modal
              fullScreen
              size="sm"
              title="Круиз"
              isOpen={cruizeFeaturesIsOpen}
              onOpen={setCruizeIsOpen}
            >
              <div className={styles.modal}>
                <Text variant="heading-3">В стоимость входит</Text>
                <ul className={styles.list}>
                  <li className={styles.listItem}>
                    Проживание на протяжении всего маршрута в каюте выбранного
                    класса — она закрепляется за вами 3-разовое или 2-разовое
                  </li>
                  <li className={styles.listItem}>
                    Питание по ресторанному меню или по системе шведского стола
                  </li>
                  <li className={styles.listItem}>
                    Возможность посещать развлекательные и познавательные
                    программы на борту
                  </li>
                </ul>
                <Text bottomGap={16} component="p">
                  Яркие воспоминания о летнем круизе, пожалуй, лучший подарок,
                  который можно сделать себе и близким. Приглашаем отправиться в
                  это увлекательное путешествие: полюбоваться пейзажами русских
                  рек, принять участие в мастер-классах на борту теплохода,
                  узнать много нового во время экскурсий в городах, повеселиться
                  на вечерних шоу-программах и отлично провести время время. Ваш
                  отдых начинается как только Вы заступите на борт судна. Теперь
                  теплоход — ваш плавучий дом отдыха.
                </Text>
                <Text variant="heading-3">Регистрация</Text>
                <Text component="p">
                  Для регистрации Вам необходимо предъявить оригинал документа
                  удостоверяющего личность (паспорт, для детей — свидетельство о
                  рождении) и электронную путевку.
                </Text>
                <Text component="p">
                  Вам необходимо прибыть в Речной порт заранее, чтобы комфортно
                  и без спешки пройти регистрацию на борт, которая обычно
                  начинается за 1,5 - 2 часа до отправления теплохода в круиз.
                </Text>
                <Text component="p">
                  Во время регистрации, Вы получаете ключ от Вашей каюты (ключ,
                  карточка), номер столика в ресторане, где будет проходить
                  завтрак, обед и ужин, а так же информационные буклеты и
                  ознакомительные листы с программой вашего круиза и распорядка
                  дня.
                </Text>
                <Text component="p">
                  Заботливые стюарды проводят Вас в вашу каюту и помогут с
                  транспортировкой багажа.
                </Text>
                <Text variant="heading-3">Заселение</Text>
                <Text component="p">
                  Обязательно проверьте целостность и рабочее состояние всего
                  оснащения вашей каюты. В зависимости от типа выбранной вами
                  каюты, а также теплохода и его класса, условия могут
                  разниться. В каютах категории выше "Эконом" всегда есть свой
                  санузел с душем. На некоторых судах предлагаются банные
                  наборы, приветственные комплименты, питьевая вода, фен,
                  холодильник, телевизор, кондиционер и т.д. При выборе каюты
                  для отдыха обратите внимание на описание каюты и теплохода,
                  чтобы обеспечить себя всеми условиями для комфортного отдыха.
                </Text>
                <Text component="p">
                  Примерное расписание дня во время путешествия:
                </Text>
                <ul className={styles.list}>
                  <li className={styles.listItem}>
                    Подъем в 7 утра, проведение утренней зарядки
                  </li>
                  <li className={styles.listItem}>
                    С 8 до 10 приглашение на завтрак в одну или две смены
                  </li>
                  <li className={styles.listItem}>
                    В час или два по полудню обед
                  </li>
                  <li className={styles.listItem}>9-20 часов вечера — ужин</li>
                </ul>
                <Text component="p">
                  О времени проведения всех остальных мероприятий вас будут
                  отдельно уведомлять. В 11 вечера отбой. Парадная и верхняя
                  палубы, бары, дискотека и ресторан закрываются. Хотя, никто не
                  запрещает в каюте заниматься тем, чем вам хочется. Главное —
                  не мешать другим пассажирам. Прогулочная палуба и
                  увеселительные заведения после 23.00 перестают работать.
                  Шуметь запрещено. Курить тоже нельзя, кроме специально
                  отведенных мест.
                </Text>
                <Text variant="heading-3">Питание</Text>
                <Text component="p">
                  В зависимости от теплохода, питание может быть организовано в
                  одну или две смены. Распределение по сменам происходит
                  равномерно по мере бронирования и заполнения круиза, также вы
                  можете выразить пожелание питаться в ту или иную смену,
                  которое мы передадим круизной компании, чаще всего она идет на
                  встречу. Питание может быть организовано по типу шведского
                  стола, накрытия или заказной системе (когда Вы сами выбираете
                  себе меню на следующий день, из предложенных вариантов).
                  Рацион подобран так, чтобы все были сыты, кроме того могут
                  быть и специальные диетические, вегетарианские или облегченные
                  блюда.
                </Text>
                <Text component="p">
                  Помимо основных ресторанов, на всех теплоходах имеется
                  несколько баров, где можно приобрести алкогольные и
                  безалкогольные напитки, закуски или заказать блюда по меню.
                  Все это не входит стоимость круиза и оплачивается пассажирами
                  самостоятельно.
                </Text>
                <Text component="p">
                  Если вы хотите взять с собой что-то из продуктов или напитков,
                  убедитесь, что в каюте имеется холодильник. У круизных
                  компаний нет запретов на какую-либо продукцию, которую можно
                  пронести на борт теплохода, основное правило — не употреблять
                  в общественных помещениях и зонах, в своей же каюте вы хозяин.
                </Text>
                <Text variant="heading-3">Расчет на борту</Text>
                <Text component="p">
                  В зависимости от теплохода, на борту может быть только
                  безналичный расчет, только наличный или система бортовых карт,
                  которой вы оплачиваете экскурсии или бар, а после круиза вам
                  выставляют счет с итоговой суммой для оплаты.
                </Text>
                <Text variant="heading-3">
                  Высадка на берег, экскурсионная программа
                </Text>
                <Text component="p">
                  Во время большинства стоянок вы сможете отправиться на
                  экскурсию или, если это зеленая стоянка, отдохнуть на пляже,
                  прокатиться на велосипеде, погулять по берегу и купить свежие
                  овощи и фрукты. Во многих городах вы можете выбрать одну из
                  нескольких экскурсий, решив что вам интереснее или приобрести
                  дополнительную.
                </Text>
              </div>
            </Modal>
            <Modal
              fullScreen
              size="sm"
              title="Маршрут"
              isOpen={cruizeRoutesIsOpen}
              onOpen={setCruizeRoutesIsOpen}
              actions={
                <div>
                  {' '}
                  <Anchor
                    href={`/api/v1/ApiCruise/GetPdfExcursion/${idCruiz}/?is_sea=1`}
                  >
                    <Icon
                      icon={
                        <IconSVG
                          name={'common/dow-pdf'}
                          width={33}
                          height={32}
                        />
                      }
                      title="Скачать файл экскурсионную программу в PDF"
                    />
                  </Anchor>
                </div>
              }
            >
              <div className={styles.modal}>
                {/* {exc_included && exc_included === '1' ? (
                <div className="wrapper">
                  <div className={styles.wrapperBorder}>
                    <div className={styles.wrapperText}>
                      <Icon
                        rightGap={8}
                        icon={adprice}
                        title="Экскурсионная программа включена встоимость"
                      />
                      <Text component="span" variant="text-4">
                        Экскурсионная программа включена встоимость
                      </Text>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="wrapper">
                  <div className={styles.wrapperBorder}>
                    <div className={styles.wrapperText}>
                      <Icon
                        rightGap={8}
                        icon={adprice}
                        title="Экскурсионная программа оплачивается на борту теплохода отдельно"
                      />
                      <Text component="span" variant="text-4">
                        Экскурсионная программа оплачивается на борту теплохода
                        отдельно
                      </Text>
                    </div>
                  </div>
                </div>
              )} */}
                {timetableExcursions.map((i, id) => (
                  <div className={styles.excursionProgram} key={id || i}>
                    <Text variant="heading-4">
                      {i.route_day} {i.town_name}
                    </Text>
                    <Text variant="heading-7" color={'returnTrip'}>
                      {i.day} день
                    </Text>
                    {i.town_name !== 'В пути' && (
                      <div className={styles.schedule}>
                        <div className={styles.scheduleItem}>
                          {i.ETS && id !== 0 && (
                            <div className={styles.scheduleDate}>
                              {i.sts_time !== '00:00' && i.sts_time}
                            </div>
                          )}
                          {/* eslint-disable-next-line no-nested-ternary */}
                          {i.STS === '0000-00-00' && i.ETS === '0000-00-00' ? (
                            i.town_name !== 'В пути' ? (
                              <div>
                                {i.sts_time === '00:00'
                                  ? ''
                                  : `${' '} Стоянка `}
                              </div>
                            ) : (
                              <div>{i.town_name}</div>
                            )
                          ) : (
                            id !== 0 && (
                              <div>
                                {i.sts_time === '00:00'
                                  ? ''
                                  : `${' '} Прибытие`}
                              </div>
                            )
                          )}
                          <div>{i.excursionProgram}</div>
                        </div>
                        {id !== timetableExcursions.length &&
                        i.ETS !== '0000-00-00' ? (
                          <div className={styles.scheduleItem}>
                            <div className={styles.scheduleDate}>
                              {i.ets_time !== '00:00' && i.ets_time}
                            </div>
                            {id !== timetableExcursions.length - 1 && (
                              <div>
                                {i.town_name !== 'В пути' && ' Отплытие'}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div>{i.town_name !== 'В пути' && ' Стоянка'}</div>
                        )}

                        {!i.excursions.length && (
                          <ExcursionGallery item={i.town_foto} />
                        )}
                      </div>
                    )}

                    {i.town_name !== 'В пути' &&
                    !!i.excursions.length &&
                    !isAstoria ? (
                      <Collapsed
                        isOpen
                        isCruis
                        items={[
                          {
                            title: (
                              <div className={styles.scheduleInfoHeader}>
                                <Icon
                                  width={30}
                                  height={30}
                                  icon={
                                    <IconSVG
                                      name={'common/add-price'}
                                      width={24}
                                      height={24}
                                    />
                                  }
                                  rightGap={8}
                                  title="Экскурсионная программа"
                                />
                                Экскурсионная программа
                              </div>
                            ),
                            body: (
                              <div>
                                <ExcursionProgramm data={i} />
                                <ExcursionGallery item={i.town_foto} />
                              </div>
                            ),
                          },
                        ]}
                      />
                    ) : (
                      <Collapsed
                        isOpen
                        isCruis
                        items={[
                          {
                            // title: (
                            //   <div className={styles.scheduleInfoHeader}>
                            //     <Icon
                            //       width={30}
                            //       height={30}
                            //       icon={
                            //         <IconSVG
                            //           name={'common/add-price'}
                            //           width={24}
                            //           height={24}
                            //         />
                            //       }
                            //       rightGap={8}
                            //       title="Экскурсионная программа"
                            //     />
                            //     Экскурсионная программа
                            //   </div>
                            // ),
                            body: (
                              <div>
                                <ExcursionProgramm
                                  data={i}
                                  isAstoria={isAstoria}
                                />
                                <ExcursionGallery item={i.town_foto} />
                              </div>
                            ),
                          },
                        ]}
                      />
                    )}
                  </div>
                ))}
              </div>
            </Modal>
          </div>
        </Layout>
        <ModalReload />
      </RootStoreProvider>
    </SearchStoreProvider>
  );
}

export const getServerSideProps = async ctx => {
  const cookies = nookies.get(ctx);
  const { token } = cookies;

  const position = randomInteger(0, 2);
  const buy = randomInteger(4, 7);
  const watch = randomInteger(6, 10);
  const city = randomInteger(30, 130);
  let motivatorColor = 'orange';
  let motivatorEmoji = '🛳';
  // Получаем только путь без query параметров
  const canonicalPath = ctx.req.url.split('?')[0];
  const queryParams = ctx.req.url.split('?')[1] || '';
  const canonicalUrl = `https://kruiz.online${canonicalPath}`;

  const motivators = [
    `Этот круиз за сегодня купили ${buy} ${declOfNum(buy, [
      'раз',
      'раза',
      'раз',
    ])}`,
    `Сейчас этот круиз смотрят ${watch} ${declOfNum(watch, [
      'человек',
      'человека',
      'человек',
    ])}`,
    `${city} ${declOfNum(city, [
      'человек',
      'человека',
      'человек',
    ])} на сайте смотрят круизы из `,
  ];
  // энкодим русские буквы для корректной работы ручки
  const encodedId = encodeURI(ctx.query.id);
  try {
    const userPromises =
      (await apiProxy
        .get(`ApiUsers/check_token/${token ?? ''}`, {
          headers: {
            'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
            ym_uid: cookies._ym_uid || 'ym_cid not found',
          },
        })
        .then(({ data }) => data)
        .catch(console.log)) ?? null;

    const cruizPromises =
      (await apiProxy
        .get(
          `ApiCruise/cruise_data/${encodedId}?${queryParams || ''}&is_sea=1`,
          {
            headers: {
              'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
              ym_uid: cookies._ym_uid || 'ym_cid not found',
            },
          },
        )
        .then(({ data }) => data)
        .catch(console.log)) ?? null;

    const clientBuy =
      (await apiProxy
        .get(`User/checkIsBuyCruise/${encodedId}/${userPromises.user.id}`, {
          headers: {
            'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
            ym_uid: cookies._ym_uid || 'ym_cid not found',
          },
        })
        .then(({ data }) => data)
        .catch(console.log)) ?? null;

    if (cruizPromises?.redirect.code !== 200) {
      return redirectFromTo(cruizPromises?.redirect, ctx);
    }
    const schemaPromises =
      (await apiProxy
        .get(`ApiShips/newShipsScheme/${cruizPromises.ship_info.id}`, {
          headers: {
            'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
            ym_uid: cookies._ym_uid || 'ym_cid not found',
          },
        })
        .then(({ data }) => data)
        .catch(console.log)) ?? null;

    const reviewsPromises = await apiProxy
      .get(`ApiReviews/viewReviews/${cruizPromises.ship_info.id}`, {
        headers: {
          'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
          ym_uid: cookies._ym_uid || 'ym_cid not found',
        },
      })
      .then(resp => resp.data)
      .catch(console.log);

    const popularPopdirsPromises =
      (await apiProxy
        .get(`ApiPopdirNew/getHeaderPopdir/1`, {
          headers: {
            'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
            ym_uid: cookies._ym_uid || 'ym_cid not found',
          },
        })
        .then(({ data }) => data)
        .catch(console.log)) ?? null;

    const promises = [
      userPromises,
      cruizPromises,
      schemaPromises,
      reviewsPromises,
      popularPopdirsPromises,
    ];

    const responses = await Promise.allSettled(promises);

    logger({
      additionalFields: {
        url: ctx.resolvedUrl,
        page_id: ctx.query.id,
      },
      level: 'debug',
      ym_uid: cookies._ym_uid,
      message: 'sea_cruise page has been created',
    });

    const [user, cruiz, schema, reviews, popularPopdirs] = responses.map(req =>
      req.status === 'fulfilled' ? req.value ?? null : null,
    );

    const motivatorReady = motivators[position];
    if (position === 2) {
      motivatorEmoji = '⚓️';
    }
    if (position === 1) {
      motivatorColor = 'red';
      motivatorEmoji = '🔥';
    }

    return {
      props: {
        cookies,
        uaString: ctx.req.headers['user-agent'],
        kek: cruiz,
        store: {
          cruiz,
          user,
          reviews,
          idCruiz: ctx.query.id,
          position,
          motivatorReady,
          clientBuy,
          motivatorColor,
          motivatorEmoji,
          schema,
          token: token || '',
          popularPopdirs,
        },
        canonicalUrl,
      },
    };
  } catch (error) {
    logger({
      additionalFields: {
        url: ctx.resolvedUrl,
        page_id: ctx.query.id,
      },
      error,
      level: 'error',
      message: 'sea_cruise page was not created',
    });
    return redirectFromTo({ url: '', code: 503 }, ctx);
  }
};
